var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"label":"dark","hide-details":"","dense":""},model:{value:(_vm.dark),callback:function ($$v) {_vm.dark=$$v},expression:"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }